import React from 'react';
import { observer } from 'mobx-react';
import { PaymentStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class PaymentCreate extends React.Component {

  onCreate = transactionId => {
      PaymentStore.create(
        {
          data: {
            subscriptionId: this.props.subscriptionId,
            transactionId,
          },
        },
        this.props.afterUpdatePayment,
      );
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Transaction ID'
        onCreate={this.onCreate}
      />
    );
  }
}

export default PaymentCreate;
